import { ButtonCustomStylesKeys } from '@unifyapps/defs/blocks/Button/types';
import { forwardRef, type JSX } from 'react';
import { default as BaseButton } from '../ButtonBase/ButtonBase';
import { defaultButtonClasses, iconSizeVariants } from './styles';
import type { ButtonProps } from './types';

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref): JSX.Element => {
  const {
    variant,
    color,
    size,
    startDecoratorComponent: StartDecoratorComponent,
    startDecoratorNode,
    endDecoratorComponent: EndDecoratorComponent,
    endDecoratorNode,
    className,
    loading,
    customStyle,
    style,
    // native-only prop — pulled out so it doesn't leak onto the DOM button
    onLongPress: _onLongPress,
    ...rest
  } = props;

  const iconClassName = iconSizeVariants({ size });

  const {
    [ButtonCustomStylesKeys.Text]: textStyle,
    [ButtonCustomStylesKeys.StartIcon]: startIconStyle,
    [ButtonCustomStylesKeys.EndIcon]: endIconStyle,
    ...restStyle
  } = customStyle ?? {};

  const styles = { ...style, ...restStyle, ...textStyle };

  const startDecorator = StartDecoratorComponent ? (
    <StartDecoratorComponent className={iconClassName} style={startIconStyle} />
  ) : (
    startDecoratorNode
  );

  const endDecorator = EndDecoratorComponent ? (
    <EndDecoratorComponent className={iconClassName} style={endIconStyle} />
  ) : (
    endDecoratorNode
  );

  return (
    <BaseButton
      ref={ref}
      {...rest}
      className={defaultButtonClasses(color, variant, size, className)}
      data-color={color}
      data-loading={loading}
      data-size={size}
      data-variant={variant}
      endDecorator={endDecorator}
      loading={loading}
      startDecorator={startDecorator}
      style={styles}
    />
  );
});

Button.displayName = 'Button';

export default Button;
